<div class="radio-wrapper" [formGroup]="formGroup">
  @for (item of radioGroup; track item) {
    <div>
      <div class="custom-radio">
        <label>
          <input
            type="radio"
            [formControlName]="item.formControlName"
            [value]="pickValue(item)"
            />
          <span class="custom-radio-btn" [ngClass]="{ rounded: rounded }"></span>
          {{ item.label }}
        </label>
      </div>
    </div>
  }
</div>
